import { render, staticRenderFns } from "./nuxt.vue?vue&type=template&id=7fa07d38&lang=html&"
import script from "./nuxt.vue?vue&type=script&lang=js&"
export * from "./nuxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "nuxt.vue"
export default component.exports